import React, { useState } from 'react';
import { FaGithub, FaLinkedin, FaInstagram, FaEnvelope, FaPaperPlane, FaSpinner } from 'react-icons/fa';

const Contact = () => {
  const [status, setStatus] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.target;
    setLoading(true);
    
    try {
      const response = await fetch('https://formspree.io/f/xbloojbz', {
        method: 'POST',
        body: new FormData(form),
        headers: {
          Accept: 'application/json'
        }
      });
      
      if (response.ok) {
        setStatus('success');
        form.reset();
      } else {
        setStatus('error');
      }
    } catch (error) {
      setStatus('error');
    } finally {
      setLoading(false);
      setTimeout(() => setStatus(''), 5000);
    }
  };

  const socialLinks = [
    {
      name: 'Email',
      icon: <FaEnvelope className="text-2xl" />,
      href: 'mailto:imran.melikov84@gmail.com'
    },
    {
      name: 'LinkedIn',
      icon: <FaLinkedin className="text-2xl" />,
      href: 'https://linkedin.com/in/imran-melikov'
    },
    {
      name: 'GitHub',
      icon: <FaGithub className="text-2xl" />,
      href: 'https://github.com/imranmelikov0'
    },
    {
      name: 'Instagram',
      icon: <FaInstagram className="text-2xl" />,
      href: 'https://instagram.com/imranmelikov225'
    }
  ];

  return (
    <section id="contact" className="py-20 bg-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">Contact</h2>
          <p className="text-lg text-gray-700">
            You can use the form below to contact me or reach out through my social media accounts.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12">
          {/* Contact Form */}
          <div className="bg-white p-8 rounded-2xl shadow-[0_8px_30px_rgb(0,0,0,0.12)] hover:shadow-[0_8px_30px_rgb(0,0,0,0.16)] transition-all duration-300">
            <form onSubmit={handleSubmit} className="space-y-6">
              <div className="relative group">
                <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1">
                  Name
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  required
                  className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:ring-2 focus:ring-primary focus:border-transparent transition-all duration-200 bg-white group-hover:border-primary"
                  placeholder="Your name"
                />
              </div>

              <div className="relative group">
                <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">
                  Email
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  required
                  className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:ring-2 focus:ring-primary focus:border-transparent transition-all duration-200 bg-white group-hover:border-primary"
                  placeholder="your.email@example.com"
                />
              </div>

              <div className="relative group">
                <label htmlFor="subject" className="block text-sm font-medium text-gray-700 mb-1">
                  Subject
                </label>
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  required
                  className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:ring-2 focus:ring-primary focus:border-transparent transition-all duration-200 bg-white group-hover:border-primary"
                  placeholder="Message subject"
                />
              </div>

              <div className="relative group">
                <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1">
                  Message
                </label>
                <textarea
                  id="message"
                  name="message"
                  required
                  rows="4"
                  className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:ring-2 focus:ring-primary focus:border-transparent transition-all duration-200 bg-white resize-none group-hover:border-primary"
                  placeholder="Write your message here..."
                ></textarea>
              </div>

              <button
                type="submit"
                disabled={loading}
                className={`w-full px-6 py-4 bg-primary text-white font-medium rounded-xl transition-all duration-300 transform hover:scale-[1.02] flex items-center justify-center space-x-2 ${
                  loading ? 'opacity-75 cursor-not-allowed' : 'hover:bg-primary/90 hover:shadow-lg'
                }`}
              >
                {loading ? (
                  <>
                    <FaSpinner className="animate-spin text-xl" />
                    <span>Sending...</span>
                  </>
                ) : (
                  <>
                    <FaPaperPlane className="text-xl" />
                    <span>Send Message</span>
                  </>
                )}
              </button>

              {status && (
                <div
                  className={`px-4 py-3 rounded-xl border-2 flex items-center justify-center text-sm transition-all duration-300 ${
                    status === 'success'
                      ? 'bg-green-50 text-green-800 border-green-200'
                      : 'bg-red-50 text-red-800 border-red-200'
                  }`}
                >
                  {status === 'success'
                    ? "Thank you for your message! We'll get back to you soon."
                    : "Oops! There was a problem sending your message. Please try again."}
                </div>
              )}
            </form>
          </div>

          {/* Social Links */}
          <div className="flex flex-col justify-center space-y-8">
            <div className="text-center md:text-left">
              <h3 className="text-xl font-semibold text-gray-900 mb-4">
                Social Media
              </h3>
              <p className="text-gray-600 mb-6">
                Follow me on these platforms and get in touch.
              </p>
            </div>

            <div className="grid grid-cols-2 gap-4">
              {socialLinks.map((link, index) => (
                <a
                  key={index}
                  href={link.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center justify-center md:justify-start space-x-3 p-4 bg-gray-50 rounded-lg hover:bg-gray-100 transition-all duration-200 transform hover:scale-105 group"
                >
                  <span className="text-primary group-hover:scale-110 transition-transform duration-200">
                    {link.icon}
                  </span>
                  <span className="text-gray-700 group-hover:text-gray-900">{link.name}</span>
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact; 